export default {
	data: function () {		
		return {	
				//!v ||	means if there is a blank value then true. It's not required value
				lng3: v => !v || (v && v.toString().length <= 3) || 'Field is less than 3 characters',
				lng6: v => !v || (v && v.toString().length <= 6) || 'Field is less than 6 characters',
				lng10: v => !v || (v && v.toString().length <= 10) || 'Field is less than 10 characters',
				lng11: v => !v || (v && v.toString().length <= 11) || 'Field is less than 11 characters',				
				lng15: v => !v || (v && v.toString().length <= 15) || 'Field is less than 15 characters',
				lng30: v => !v || (v && v.toString().length <= 30) || 'Field is less than 30 characters',
				lng50: v => !v || (v && v.toString().length <= 50) || 'Field is less than 50 characters',
				lng100: v => !v || (v && v.toString().length <= 100) || 'Field is less than 100 characters',
				lng200: v => !v || (v && v.toString().length <= 200) || 'Field is less than 200 characters',
				spaces: v => !v || (v || '').indexOf(' ') < 0 || v + '_ No spaces are allowed',
				phoneNum: v => !v || (/^(?:\+88|01)?(?:\d{6}|\d{7}|\d{9}|\d{11}|\d{13})$/).test(v) || "Enter valied phone/mobile number",
				phoneNum: v => !v || (/^(?:\+88|01)?(?:\d{6}|\d{7}|\d{9}|\d{11}|\d{13})$/).test(v) || "Enter valied phone/mobile number",				
				faxNum: v => !v || (/^\+?[0-9]+$/).test(v) || "Enter valied fax number",
				email : v => !v || /.+@.+/.test(v) || 'E-mail must be valid',
				decimal : v => !v || (/^\d*(\.\d{0,5})?[0-9]$/).test(v) || "Enter number only no less than zero",
				decimalShort : v => !v || (/^\d*(\.\d{0,5})?[0-9]$/).test(v) || "Enter Number only",
				number : v => !v || (/^\d*(\.\d)?[1-9]$/).test(v) || "Enter the number greater than zero",
				IpPhone : v => !v || (/^\d*(\.\d)?[0-9]$/).test(v) || "Enter the number only",
				//decimal2 : v => !v || (/^\d*(\.\d{1,5})?$/).test(v) || "Enter number only",
				specialChar : v => !v || (/^[A-Za-z0-9 ]+$/).test(v) || "Remove special character",
		}
	},

}


// WEBPACK FOOTER //
// ./src/mixins/validationRules.js